
export let baseURL = ""
export let WSSURL = ""
switch (process.env.NODE_ENV) {
    case 'development':
        baseURL = "https://dcapi.hongchaoshijie.com"  //开发环境url
        WSSURL = "dcapi.hongchaoshijie.com:8989"
        break
    case 'production':
        baseURL = "https://dcapi.hongchaoshijie.com"
        WSSURL = "dcapi.hongchaoshijie.com:8989"
        break
}

export default {
    baseURL,
    WSSURL
}



// WEBPACK FOOTER //
// ./src/assets/js/baseURL.js